module.exports = __webpack_public_path__ + "static/media/a30.d8eb8b88.jpg";